import Strings_en from "./en/strings.json";

const Locale = {
  en: { strings: Strings_en },
};

export default Locale;
